import React, { useContext } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import GeoContext from 'contexts/geoContext'
import AutoTooltip from 'components/Common/AutoTooltip'
import AutoTooltipContent from 'components/Common/AutoTooltip/AutoTooltipContent'
import SolidExclamationCircleIcon from 'components/Luxkit/Icons/solid/SolidExclamationCircleIcon'
import Caption from 'components/Luxkit/Typography/Caption'

const DateToolTipWrapper = styled.span`
  display: inline-flex;
`

const StyledExclamationCircleFullIcon = styled(SolidExclamationCircleIcon)`
  margin: auto;
  margin-left: 4px;
`

const TooltipContent = styled(Caption)`
  margin-top: ${rem(4)};
`

function AtolProtectedTooltipContainer() {
  const { currentRegionCode } = useContext(GeoContext)
  const showATOL = currentRegionCode === 'GB'

  if (!showATOL) {
    return null
  }

  return (
    <AutoTooltip>
      <DateToolTipWrapper>
        <Caption variant="medium">ATOL protected</Caption>
        <StyledExclamationCircleFullIcon colour="primary" size="XS" />
      </DateToolTipWrapper>
      <AutoTooltipContent
        width={180}
        style={{ left: rem(95), alignContent: 'center' }}
      >
        <Caption variant="medium" weight="bold">This trip is ATOL protected</Caption>
        <TooltipContent variant="medium">for your full peace of mind.</TooltipContent>
      </AutoTooltipContent>
    </AutoTooltip>
  )
}

export default AtolProtectedTooltipContainer
